import { Session } from "@talkjs/react";
import { ErrorBoundary } from "@shared/ui/ErrorBoundary";
import { TalkJSData } from "../../chat.types";

export type Props = {
  talkjsData: TalkJSData;
  children: React.ReactNode;
};

export function ChatSession({ talkjsData, children }: Props) {
  if (!talkjsData) {
    return children;
  }

  if (!talkjsData.app_id || !talkjsData.user_id || !talkjsData.token) {
    return children;
  }

  return (
    <ErrorBoundary fallback={<>{children}</>}>
      <Session
        appId={talkjsData.app_id}
        userId={talkjsData.user_id}
        token={talkjsData.token}
      >
        {children}
      </Session>
    </ErrorBoundary>
  );
}

export default ChatSession;
